
export const homeLocation = '/'
export const aboutLocation = '/about'
export const menuCardLocation = '/menu'
export const dishLocation = '/gerechten'
export const galleryLocation = '/gallery'
export const contactLocation = '/contact'
export const privacyLocation = '/privacy-policy'
export const termsLocation = '/terms-of-service'
export const cookieLocation = '/cookies'
export const siteMapLocation = '/site-map'
export const tableBooker = 'https://book.restomanager.net/reservations/6a2143926a6b8bfe1ee1665d'



